import { styled } from "@mui/material/styles";
import { Container } from "@mui/material";

import loader from "assets/images/hamster.gif";

const StyledContainer = styled(Container)({
  padding: "100px 0",
  width: "inherit",
  height: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const CurrentUserSpinner = () => {
  return (
    <StyledContainer>
      <img src={loader} alt="loader" />
    </StyledContainer>
  );
};

export default CurrentUserSpinner;
